import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export const vReveal = {
  mounted(el, binding) {
    const opts = binding.value || {}
    const y = opts.y ?? 32
    const duration = opts.duration ?? 0.7
    const delay = opts.delay ?? 0
    const scale = opts.scale ?? 0.97
    const stagger = opts.stagger ?? 0

    if (stagger && el.children.length > 0) {
      gsap.set(el.children, { opacity: 0, y, scale })
      ScrollTrigger.create({
        trigger: el,
        start: 'top 88%',
        once: true,
        onEnter() {
          gsap.to(el.children, {
            opacity: 1,
            y: 0,
            scale: 1,
            duration,
            delay,
            stagger,
            ease: 'power3.out',
            clearProps: 'transform'
          })
        }
      })
    } else {
      gsap.set(el, { opacity: 0, y, scale })
      ScrollTrigger.create({
        trigger: el,
        start: 'top 88%',
        once: true,
        onEnter() {
          gsap.to(el, {
            opacity: 1,
            y: 0,
            scale: 1,
            duration,
            delay,
            ease: 'power3.out',
            clearProps: 'transform'
          })
        }
      })
    }
  }
}
